// components/AlertIconDisplay.tsx
import React from "react";
import { Box } from "@mui/material";
import { ALERT_ICON_MAP } from "../../services/Constants";
import Badge from "@mui/material/Badge";
import { HiOutlineBellAlert } from "react-icons/hi2";
import Grid from "@mui/material/Grid";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";

const AlertIconDisplay = ({ alertType }) => {
  const iconData = ALERT_ICON_MAP[alertType?.category];
  const IconComponent = iconData?.icon ? iconData?.icon : HiOutlineBellAlert;
  const props = iconData?.props
    ? iconData?.props
    : { color: "primary", size: "2em" };

  return (
    <>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
          <Box>
            {" "}
            {alertType.count <= 1 ? (
              <Badge>
                <IconComponent {...props} />
              </Badge>
            ) : (
              <Badge badgeContent={alertType?.count} color="primary">
                <IconComponent {...props} />
              </Badge>
            )}
          </Box>
        </Grid>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
          <Box sx={{ mt: 0.5, ml: 0.5 }}>{alertType?.category}</Box>
        </Grid>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
          <Box sx={{ mt: 0.5, textAlign: "right" }}>
            {/* {formatDate(alertType?.messages[0].createdAt)} */}
            <DateAndTimeGridCell
              value={alertType?.messages[0].createdAt}
              singleLine={true}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
          {alertType.count <= 1 && (
            <Box
              sx={{
                mt: 0.8,
                ml: 0.5,
                textAlign: "left",
                color: "text.secondary",
              }}
            >
              {alertType?.messages[0].message}
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default AlertIconDisplay;
